module.exports = __webpack_public_path__ + "img/icon-import.b4de1569.svg";